import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SharedModule }       from '../shared/shared.module';
import { SyncXeroComponent }  from './xero.sync.component';
import { XeroErrorComponent } from './xero.error.component';
import { XeroService }        from './xero.service';

@NgModule({
  declarations: [
    SyncXeroComponent,
    XeroErrorComponent
  ],
  entryComponents: [
    SyncXeroComponent,
    XeroErrorComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    XeroService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class XeroModule {}
